import React from 'react';
import Background from './background';

class Whele extends React.Component{
	constructor(props){
		super(props);

		this.state = {
			display: 0,
		}

		setTimeout(() => {
			this.setState({display:1});
		}, 500);
		setTimeout(() => {
			this.setState({display:2});
		}, 1000);
		setTimeout(() => {
			this.setState({display:3});
		}, 1500);
	}

	onResize = ()=>{
		this.forceUpdate();
	}

	componentDidMount(){
		window.addEventListener("resize", this.onResize);
	}
	
	componentWillUnmount(){
		window.removeEventListener("resize", this.onResize);
	}

	textCommon = {dominantBaseline:"middle", textAnchor:'middle', fill:"#00000099", fontSize:6.5};
	mouseDown(e, nth){
		this.props.setPage(nth);
	}

	getTextWidth(text, ratio){
		const element = document.createElement('canvas');
		const context = element.getContext('2d');
		context.font = this.textCommon.fontSize*ratio + "px Tilt Neon";
		return context.measureText(text).width;
	}

	circleText(text, radius, ratio, step){
		const result = [];

		const words = text.split(" ");

		for(let i in words){
			const steps = words[i].length;
			const inversed = (+i % 2) == 0;

			for(let j in words[i]){
				const letter = words[i][j];

				let angle = (steps/2 - j - 0.5) * Math.PI/8;

				angle +=Math.PI/2;
				if(inversed) angle *= -1;

				const x = Math.cos(angle) * radius;
				const y = Math.sin(angle) * radius;
				result.push(
					<text aria-label={text} {...this.textCommon}
						fontSize={this.textCommon.fontSize*(this.props.isMobile ? 1.4:ratio)}
						transform={`rotate(${angle/Math.PI*180 -90})`}
						rotate={(inversed? 180:0)}
						x={50 + (inversed? this.getTextWidth(letter, (this.props.isMobile ? 1.4:ratio)) : 0)}
						y={50*ratio+radius - (inversed ? this.textCommon.fontSize/2*(this.props.isMobile ? 1.4:ratio) : 0)}
						key={`${i}${j}`}>
						{letter}
					</text>
				)
				/*result.push(
					<circle	cx={50+x} cy={50*ratio + y} r={0.5*ratio} key={`+${i}${j}`} fill="#ffffff"/>
				)*/
			}
		}

		return result;
	}

	render(){
		const ratio = window.innerHeight/window.innerWidth;

		const circleWidth = this.props.isMobile ? 45 : 32*ratio;

		const letterRadius = (scale = 1)=>{
			return this.props.isMobile ?
			45/scale - (45 - 45/1.5)/2
			: 32*ratio/scale - (32*ratio - 32*ratio/1.5)/2
		};

		
		return (
			<svg className="background-svg" height="100%" width="100%" viewBox={this.props.isMobile ? "0 "+(-40*ratio)+" 100 "+(100*ratio) : "0 0 100 "+(100*ratio)}>
				<Background ratio={ratio} isMobile={this.props.isMobile}/>
				<circle className={this.state.display < 3 ? "hidden" : "shown"}
					cx="50" cy={50*ratio} r={circleWidth}
					fill="#ff5555"
					onMouseDown={(e)=>this.mouseDown(e, 2)}
				/>
				<g>
					{this.circleText(this.props.isMobile ? "Projects" : "Worthy Projects", letterRadius(1), ratio)}
				</g>
				<circle className={this.state.display < 2 ? "hidden" : "shown"}
					cx="50" cy={50*ratio} r={circleWidth/1.5}
					fill="#ff8888"
					onMouseDown={(e)=>this.mouseDown(e, 1)}
				/>
				<g>
					{this.circleText(this.props.isMobile ? "Talents" : "Talents Skills", letterRadius(1.5), ratio)}
				</g>
				<circle className={this.state.display < 1 ? "hidden" : "shown"}
					cx="50" cy={50*ratio} r={circleWidth/3}
					fill="#ffaaaa"
					onMouseDown={(e)=>this.mouseDown(e, 0)}
				/>
				<g>
					<text {...this.textCommon} fontSize={this.textCommon.fontSize* (this.props.isMobile ? 1.4:ratio)} x={50} y={50*ratio}>Me</text>
				</g>
			</svg>
		)
	}
}

export default Whele;